import BigNumber from 'bignumber.js'
import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { Button, Heading, Text, Link, Flex } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import {CHAINS, switchChain} from 'utils/wallet'
import { Config } from 'utils/bridgeUtils'
import { useChainId, useConnectedAddress } from 'hooks/useWeb3'
import Select from 'components/SelectInput'
import Input from 'components/Input'
import BalanceInput from 'components/Input/BalanceInput'
import { OptionProps } from 'components/SelectInput/SelectInput'
import { useClaim } from '../hooks/useBridge'

const StyledContainer = styled.div`
  text-align: center;
  position: relative;
  padding-top: 20px;
`;

const Content = styled.div`
  display: inline-block;
  background: ${({ theme }) => (theme.isDark ? 'rgb(44, 41, 38)' : 'white')};
  box-shadow: 2px 2px 8px ${({ theme }) => (theme.isDark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)')};
  border-radius: 32px;
  padding: 30px 25px;
  position: relative;
  width: 600px;

  @media (max-width: 700px) {
    width: 100%;
    padding: 30px 15px;
  }
`

const Row = styled.div`
    margin-top: 25px;
`;

const Label = styled(Text)`
  text-align: left;
  padding-left: 16px;
  margin-bottom: 5px;
`

const ErrorRow = styled(Text)`
  text-align: center;
  color: #ff6a6a;
  margin-top: 5px;
`

const Chains = Object.keys(Config.chains).map(c=>Number(c));
const ChianIndex:any = {};
Chains.forEach((c,i)=>{ChianIndex[c]=i});
const ChainOptions = Chains.map(c=>{
  const info = Config.chains[c];
  return {
    label: info.name,
    value: c,
    img: { 
      url: `/images/bridge/chains/${info.symbol}.png`, 
      name: info.symbol
    }
  };
});
const getChainShortName = (chainId) => {
  const info = Config.chains[chainId];
  return info?.shortName || "";
}

const Core = () => {
  const TranslateString = useI18n();
  const chainId = useChainId();
  const connectedAddress = useConnectedAddress();

  const [fromChainId, setFromChainId] = useState(56);
  const [toChainId, setToChainId] = useState(10000);
  
  const [txId, setTxId] = useState("")
  const [error, setError] = useState("");

  useEffect(()=>{
      setError("");
    } , 
    // eslint-disable-next-line
    [fromChainId, connectedAddress, txId]
  )

  const handleFromChainChange = (option: OptionProps): void => {
    const s=option.value;
    setFromChainId(s);
    if (toChainId === s) {
      setToChainId(Chains.find(c=>c!==s));
    }
  }

  const handleToChainChange = (option: OptionProps): void => {
    const s=option.value;
    setToChainId(s);
    if (fromChainId === s) {
      setFromChainId(Chains.find(c=>c!==s));
    }
  }

  const renderFromChainSelect = () => {
    return (
      <div>
        <Label>{TranslateString(2028,'From: ')}</Label>
        <Flex style={{height:"72px"}}>
          <Select options={ChainOptions} onOptionChange={handleFromChainChange} selectIndex={ChianIndex[fromChainId]}/>
        </Flex>
      </div>
    );
  }

  const renderToChainSelect = () => {
    return (
      <Row>
        <Label>{TranslateString(2029,'To: ')}</Label>
        <Flex style={{height:"72px"}}>
          <Select options={ChainOptions} onOptionChange={handleToChainChange} selectIndex={ChianIndex[toChainId]}/>
        </Flex>
      </Row>
    );
  }

  const handleTxChange = (e: React.FormEvent<HTMLInputElement>) => {
    setError("");
    setTxId(e.currentTarget.value);
  }

  const renderTx = () => {
    return (
      <Row>
        <Label>{TranslateString(2035,'Transaction Hash')}{TranslateString(1108,':')}</Label>
        <Input placeholder={TranslateString(2035,'Transaction Hash')} value={txId} onChange={handleTxChange} />
      </Row>
    )
  }

  const [requested, setRequested] = useState(false);

  const onClaim = useClaim(fromChainId, toChainId, txId && txId.trim(), connectedAddress);

  const onAnyRequestStart = () => {
    setError("");
    setRequested(true);
  }

  const renderButton = () => {
    if (chainId !== toChainId) {
      return (
        <Button disabled={requested} onClick={async () => {
          try {
            onAnyRequestStart()
            await switchChain(toChainId);
            setRequested(false)
          } catch (e) {
              console.error(e)
          }
        }}>
          {TranslateString(2032,'Switch to ')}{getChainShortName(toChainId)}{TranslateString(2033,' Network')}
        </Button>
      )
    }

    const isProbablyValid = txId && txId.length && txId.startsWith('0x') && txId.length > 60;
    return (
      <Button disabled={requested || !isProbablyValid} onClick={async()=>{
        try {
          onAnyRequestStart()
          const result = await onClaim();
          if (result && !result.isSuccess) {
            setError(result.message)
          }
          setRequested(false)
        } catch (e) {
            console.error(e)
        }
      }}>
        {TranslateString(2034,'Claim')}
      </Button>
    );
  }

  const renderButtonRow = () => {
    return (
      <Row>
        {renderButton()}
      </Row>
    );
  }

  const renderErrorRow = () => {
    return error ? (
      <ErrorRow>{error}</ErrorRow>
    ) : ""
  }

  return (
    <StyledContainer>
      <Content>
        {renderFromChainSelect()}
        {renderToChainSelect()}
        {renderTx()}
        {renderButtonRow()}
        {renderErrorRow()}
      </Content>
    </StyledContainer>
  )
}

export default Core
